import React from 'react';
import { NODE_TYPE_CONFIGS } from '../constants';

const nodeColorMap = Object.fromEntries(
  NODE_TYPE_CONFIGS.map(c => [c.type, c.iconColor])
);

const NodeContent = ({ data }) => {
  const color = data.iconColor || nodeColorMap[data.type] || '#666';
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        textAlign: 'center',
        wordBreak: 'break-word',
      }}
    >
      {data.icon && React.createElement(data.icon, { style: { fontSize: '14px', color, flexShrink: 0 } })}
      <span>{data.taskName || data.label}</span>
    </div>
  );
};

export default NodeContent;
